export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://192.168.1.41:8000/api';

const SAFE_METHODS = ['GET', 'HEAD', 'OPTIONS'];

function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

// Session expiree/absente (ex: 1h d'inactivite, cf. SESSION_COOKIE_AGE cote
// backend) -> DRF renvoie 403 (pas 401 : SessionAuthentication n'a pas de
// WWW-Authenticate header, donc NotAuthenticated est requalifiee en 403 par
// DRF) avec TOUJOURS ce detail exact ("Authentication credentials were not
// provided.", texte par defaut de NotAuthenticated). On s'appuie sur CE texte
// precis pour distinguer "plus connecte du tout" d'un 403 legitime de
// permission metier (ex: HasSupervisorModelPermission/IsSuperUser, qui ont
// leur propre message ou le texte par defaut DIFFERENT de PermissionDenied,
// "You do not have permission...") — seul le premier cas doit renvoyer vers
// le login, le second doit rester affiche comme une erreur normale sur la
// page. Sans cette distinction, retirer une permission a un compte connecte
// l'aurait deconnecte a tort.
const SESSION_EXPIRED_DETAIL = 'Authentication credentials were not provided.';

function loginPathFor(pathname) {
  if (pathname.startsWith('/superadmin/')) return '/superadmin/login';
  if (pathname.startsWith('/sub-supervisor/')) return '/sub-supervisor/login';
  if (pathname.startsWith('/supervisor/')) return '/login'; // login unique (company + superviseur)
  return '/login';
}

function handleAuthError(response, detail) {
  if (response.status !== 401 && response.status !== 403) return;
  if (detail?.detail !== SESSION_EXPIRED_DETAIL) return;
  const target = loginPathFor(window.location.pathname);
  // Deja sur le bon ecran de login (ex: le ping de session au montage d'un
  // AuthContext, cf. AuthContext.jsx, echoue normalement tant que personne
  // n'est connecte) -> ne pas re-naviguer inutilement.
  if (window.location.pathname !== target) {
    window.location.href = target;
  }
}

async function apiRequest(path, { method = 'GET', body } = {}) {
  const headers = {};
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  if (!SAFE_METHODS.includes(method)) {
    const csrfToken = getCookie('csrftoken');
    if (csrfToken) headers['X-CSRFToken'] = csrfToken;
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    credentials: 'include',
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (!response.ok) {
    const detail = await response.json().catch(() => null);
    handleAuthError(response, detail);
    throw new Error(detail ? JSON.stringify(detail) : `Erreur API (${response.status})`);
  }

  if (response.status === 204) return null;
  return response.json();
}

// Pour l'upload de fichiers (ex: logo) — pas de Content-Type manuel, le navigateur
// pose lui-meme le boundary multipart pour un FormData.
export async function apiUpload(path, formData, { method = 'PATCH' } = {}) {
  const headers = {};
  const csrfToken = getCookie('csrftoken');
  if (csrfToken) headers['X-CSRFToken'] = csrfToken;

  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    credentials: 'include',
    headers,
    body: formData,
  });

  if (!response.ok) {
    const detail = await response.json().catch(() => null);
    handleAuthError(response, detail);
    throw new Error(detail ? JSON.stringify(detail) : `Erreur API (${response.status})`);
  }

  return response.json();
}

export default apiRequest;
